import React from "react";
import { useField, useFormikContext } from "formik";
import {
  TextField,
  MenuItem,
} from "@mui/material";

export default function MultiSelectField({ name, label, items = [] }) {
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const [field, meta] = useField(name);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setFieldValue(name, typeof value === "string" ? value.split(",") : value);
  };

  return (
    <TextField
      select
      fullWidth
      size="small"
      label={label}
      value={field.value || []}
      onChange={handleChange}
      onBlur={() => setFieldTouched(name, true)}
      error={Boolean(meta.touched && meta.error)}
      helperText={meta.touched && meta.error}
      SelectProps={{
        multiple: true,
        renderValue: (selected) =>
          items
            .filter((item) => selected.includes(item.code))
            .map((item) => item.name)
            .join(", "),
      }}
    >
      {items.map((item) => (
        <MenuItem key={item.code} value={item.code}>
          {item.name}
        </MenuItem>
      ))}
    </TextField>
  );
}
